import { RouterTypeDto } from '../api/core';

export interface RouterTypesState {
    loading: number;
    routerTypes: RouterTypeDto[];
    initiallyLoaded: boolean;
}

export enum RouterTypeActionTypes {
    LOADING = '@liebherr/routerTypes/loading',
    LOADING_DONE = '@liebherr/routerTypes/loading_done',
    LOAD_ROUTER_TYPES = '@liebherr/routerTypes/load_routerTypes',
    LOADED_ROUTER_TYPES = '@liebherr/routerTypes/loaded_routerTypes',
}

export const routerTypesFeatureKey = 'routerTypes';
